import { formatUsd } from '../../utils/formatCurrency';
import { useAnimatedLeaderboardScore } from '../../hooks/useAnimatedLeaderboardScore';

/**
 * Leaderboard / stats earnings: counts up when `score` increases (e.g. after payout).
 */
export default function AnimatedUsdScore({ score, durationMs = 1000, className }) {
  const n = typeof score === 'number' && Number.isFinite(score) ? score : null;
  const animated = useAnimatedLeaderboardScore(n, durationMs);
  const text = animated == null ? '—' : formatUsd(animated);
  return (
    <span className={className} style={{ fontVariantNumeric: 'tabular-nums' }}>
      {text}
    </span>
  );
}
